import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { ALIGN_OPTIONS, ALIGN_SELF_OPTIONS, DIRECTION_OPTIONS, JUSTIFY_OPTIONS, WRAP_OPTIONS } from './TFlexConstants';
import { toPx } from '../../../utils/toPx';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { objectSymmetricDifference } from './TFlex.utils';

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "TFlex__StyledFlex"
})(({
  $align,
  $alignSelf,
  $direction,
  $gap,
  $justify,
  $position,
  $wrap,
  $zIndex,
  $cssStyles
}) => {
  return Object.assign({
    alignItems: ALIGN_OPTIONS[$align],
    alignSelf: ALIGN_SELF_OPTIONS[$alignSelf],
    display: 'flex',
    flexDirection: DIRECTION_OPTIONS[$direction],
    gap: $gap && toPx($gap),
    inlineSize: '100%',
    '& > div[data-tflex="true"]': {
      width: 'auto'
    },
    justifyContent: JUSTIFY_OPTIONS[$justify],
    flexWrap: WRAP_OPTIONS[$wrap],
    flexGrow: 1,
    maxInlineSize: '100%',
    position: $position,
    zIndex: $zIndex,
    textDecoration: 'inherit'
  }, $cssStyles);
});
export const TFlexWithRef = (_ref, ref) => {
  let {
      align = 'start',
      alignSelf = 'auto',
      direction = 'row',
      gap = 0,
      justify = 'start',
      position,
      wrap = 'nowrap',
      zIndex,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["align", "alignSelf", "direction", "gap", "justify", "position", "wrap", "zIndex", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  const {
    domProps: __domProps,
    tokenProps
  } = filterProps(rest);
  const forwardedRestProps = objectSymmetricDifference(rest, tokenProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledFlex, Object.assign({}, forwardedRestProps, {
    ref: ref,
    "data-tflex": "true",
    $align: align,
    $alignSelf: alignSelf,
    $direction: direction,
    $gap: gap,
    $justify: justify,
    $position: position,
    $wrap: wrap,
    $zIndex: zIndex,
    $cssStyles: cssStyles,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'TFlex'
  }));
};

/**
 * The name TFlex is to differentiate it with the modernized Flex component,
 * this means the foundations-editor doesn't need to be updated to handle
 * components with the same name from different import paths.
 */
export const TFlex = /*#__PURE__*/forwardRef(TFlexWithRef);
TFlex.displayName = 'TFlex';